module.exports = __webpack_public_path__ + "static/media/image2.d92ed9b4.jpg";